module.exports = __webpack_public_path__ + "static/media/yt-rockets-sing.0fb47221.mov";